import React, { useState, useEffect, useRef } from "react";
import PopupStyle from "../../style/PopUp.module.css";
import Style from "../../style/Pages/Auth/AuthPassword.module.css";
import images from "../../utils/images";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import AuthPassInputField from "../../components/ui/input/AuthInputs/AuthInputPassword";
import Button from "../../components/ui/buttons/Button";
import { useForgotPassword } from "../../hooks/useAuth"; // Changed hook
// import { Loader } from "lucide-react";
import AuthInputField from "../../components/ui/input/AuthInputs";
import AuthCode from "react-auth-code-input";
import Loader from "../../components/ui/Loader/Loader";
import MainStyle from "../../style/Main.module.css";

const ForgotPassword = ({ OnClose }) => {
  // Changed to useForgotPassword hook
  const {
    formData,
    loading,
    errors,
    step,
    isResending,
    canResend,
    resendCooldown,
    stepErrors,
    handleResendOTP,
    handleInputChange,
    handleSubmitEmail,
    handleSubmitReset,
    handleSubmitOTP, // NEW: Handler for OTP submission
  } = useForgotPassword(OnClose);

  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  const modalRef = useRef(null);

  // Detect outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        OnClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [OnClose]);

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const calculatePasswordStrength = (password) => {
    if (!password) return 0;
    let strength = 0;
    if (password.length >= 8) strength += 25;
    if (/[A-Z]/.test(password)) strength += 25;
    if (/[0-9]/.test(password)) strength += 25;
    if (/[!@#$%^&*]/.test(password)) strength += 25;
    return strength;
  };

  const getStrengthColor = (strength) => {
    if (strength < 30) return "#ff4d4f";
    if (strength < 60) return "#faad14";
    if (strength < 80) return "#a0d911";
    return "#52c41a";
  };

  const strength = calculatePasswordStrength(formData.new_password);
  const strengthColor = getStrengthColor(strength);

  return (
    <div className={PopupStyle.popupBackground}>
      <div className={Style.authPasswordContainer} ref={modalRef}>
        <div className={Style.authPasswordMain}>
          <div className={Style.authHeaderSection}>
            <div>
              <div className={Style.authHeadImg}>
                {/* Changed image for forgot password */}
                <img src={images.forgotpassword} alt="Forgot Password" />
              </div>
              {/* Step-based headers */}
              <h2>
                {" "}
                {step === 1 && "Reset Password"}
                {step === 2 && "Verify OTP"}
                {step === 3 && "Create New Password"}
              </h2>
              <p>
                {step === 1 && "Enter your email to reset your password"}
                {step === 2 && "Enter the OTP sent to your email"}
                {step === 3 && "Create a new secure password"}
              </p>
            </div>
          </div>

          <div className={Style.authPasswordContent}>
            {step === 1 ? (
              // STEP 1: EMAIL INPUT
              <>
                <p>
                  Please enter your email address. We'll send an OTP to your
                  inbox to continue.
                </p>

                <div className={Style.inputField}>
                  <AuthInputField
                    label="Email"
                    type="text"
                    name="email"
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    placeholder="Enter your email"
                    error={errors.email}
                    required
                  />
                </div>
                <div className={Style.bottomButton}>
                  <Button onClick={handleSubmitEmail}>
                    {loading ? <Loader /> : "Send"}
                  </Button>
                </div>
              </>
            ) : step === 2 ? (
              <>
                {" "}
                <p>
                  Enter the 6-digit OTP sent to your email. This helps us
                  confirm it's really you.
                </p>
                <AuthCode
                  value={formData.otp || ""}
                  //   onChange={(otp) =>
                  //     onChange({ target: { name: "otp", value: otp } })
                  //   }
                  onChange={(otp) => handleInputChange("otp", otp)}
                  allowedCharacters="numeric"
                  length={5} // Change as needed
                  // ref={authCodeRef}
                  containerClassName={Style.otpBoxClass}
                  inputClassName={Style.authInputOtp}
                />
                {stepErrors.otp && (
                  <div className={MainStyle.errorMsgCenter}>
                    {stepErrors.otp}
                  </div>
                )}
                {errors.api && (
                  <div className={MainStyle.errorMsgCenter}>{errors.api}</div>
                )}
                <div>
                  {!canResend ? (
                    <p className={MainStyle.textAlignCenter}>
                      Resend available in {resendCooldown?.minutes ?? 0}:
                      {(resendCooldown?.seconds ?? 0)
                        .toString()
                        .padStart(2, "0")}
                    </p>
                  ) : (
                    // <button
                    //   type="button"
                    //   onClick={handleResendOTP}
                    //   className={AuthStyle.resendButton}
                    //   disabled={!canResend}
                    // >
                    //   Resend OTP
                    // </button>
                    <p
                      className={MainStyle.textAlignCenter}
                      style={{
                        color: "cornflowerblue",
                        cursor: isResending ? "default" : "pointer",
                        pointerEvents: isResending ? "none" : "auto",
                      }}
                      onClick={handleResendOTP}
                    >
                      {isResending ? (
                        <div>
                          <Loader color="#3b82f6" />
                        </div>
                      ) : (
                        "Resend"
                      )}
                    </p>
                  )}
                </div>
                <div className={Style.bottomButtonCenter}>
                  <Button onClick={handleSubmitOTP}>
                    {loading ? <Loader /> : "Verify"}
                  </Button>
                </div>
              </>
            ) : (
              <>
                <AuthPassInputField
                  label="New Password"
                  value={formData.new_password}
                  onChange={(e) =>
                    handleInputChange("new_password", e.target.value)
                  }
                  type={showPassword.new ? "text" : "password"}
                  placeholder="Enter new password"
                  error={errors.new_password}
                  icon={showPassword.new ? faEye : faEyeSlash}
                  onIconClick={() => togglePasswordVisibility("new")}
                  required
                />

                <div className={Style.passwordstrengthmeter}>
                  <div
                    className={Style.strengthbar}
                    style={{
                      width: `${strength}%`,
                      backgroundColor: strengthColor,
                    }}
                  ></div>
                </div>
                <div className={Style.strengthlabel}>
                  Password strength:
                  <span style={{ color: strengthColor }}>
                    {strength < 30
                      ? " Weak"
                      : strength < 60
                      ? " Fair"
                      : strength < 80
                      ? " Good"
                      : " Strong"}
                  </span>
                </div>

                <div className={Style.passwordrequirements}>
                  <p>Password must contain:</p>
                  <ul>
                    <li
                      className={
                        formData.new_password.length >= 8 ? Style.valid : ""
                      }
                    >
                      At least 8 characters
                    </li>
                    <li
                      className={
                        /[A-Z]/.test(formData.new_password) ? Style.valid : ""
                      }
                    >
                      One uppercase letter
                    </li>
                    <li
                      className={
                        /[0-9]/.test(formData.new_password) ? Style.valid : ""
                      }
                    >
                      One number
                    </li>
                    <li
                      className={
                        /[!@#$%^&*]/.test(formData.new_password)
                          ? Style.valid
                          : ""
                      }
                    >
                      One special character
                    </li>
                  </ul>
                </div>

                <AuthPassInputField
                  label="Confirm Password"
                  value={formData.confirm_password}
                  onChange={(e) =>
                    handleInputChange("confirm_password", e.target.value)
                  }
                  type={showPassword.confirm ? "text" : "password"}
                  placeholder="Confirm new password"
                  error={errors.confirm_password}
                  icon={showPassword.confirm ? faEye : faEyeSlash}
                  onIconClick={() => togglePasswordVisibility("confirm")}
                  required
                />

                <div className={Style.bottomButton}>
                  <Button onClick={handleSubmitReset}>
                    {loading ? <Loader /> : "Reset Password"}
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
